// import { createTheme } from "@mui/material/styles";
// import { io } from "socket.io-client";
// import { wsEndpoint } from "./backend";

// function UserConfig() {
//   // 如果有現成的就丟回去 沒有的話 執行第一次建構
//   if (typeof UserConfig.cache === "object") {
//     return UserConfig.cache;
//   }
//   this.hkoLang = "tc";
//   UserConfig.cache = this;
// }

// function AppSingleton() {
//   if (typeof AppSingleton.cache === "object") {
//     return AppSingleton.cache;
//   }
//   // TODO: binding the leave page and navigation
//   this.topBarHeight = 64; // MARK: Now only for recycling game
//   this.leavePage = () => {
//     const onAnimationCompleted = () => {
//       this.navigate(-1);
//     };
//     return onAnimationCompleted;
//   };
//   this.theme = createTheme({
//     transitions: {
//       easing: {
//         easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
//         easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
//         easeIn: "cubic-bezier(0.4, 0, 1, 1)",
//         sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
//       },
//     },
//   });
//   this.notifications = [];
//   this.faiChunCallbackDict = {}; // MARK: {filename/scopeName: callback func}
//   this.faiChunResetCallbackDict = {};
//   this.emojiCallback = {};

//   // MARK: notifications & setNotifications will be set from the App.js
//   try {
//     this.socket = io(wsEndpoint, {
//       transports: ["websocket", "polling"],
//       autoConnect: true,
//     });
//     console.log("Socket exists");

//     this.socket.on("connect", () => {
//       console.log("Connected to server");
//     });
//     this.socket.on("disconnect", () => {
//       console.log("Disconnected from server");
//     });
//     this.socket.on("reconnect", () => {
//       console.log("Reconnected to server");
//     });
//     this.socket.on("message", (message) => {
//       // console.log("message received");
//       // console.log(message);
//       if (message.category === "fai_chun_broadcast") {
//         Object.values(this.faiChunCallbackDict).forEach((func) => {
//           func(message.data);
//         });
//       } else if (message.category === "fai_chun_reset_broadcast") {
//         Object.values(this.faiChunResetCallbackDict).forEach((func) => {
//           func(message.data);
//         });
//       } else if (message.category === "emoji_broadcast") {
//         Object.values(this.emojiCallback).forEach((func) => {
//           func(message.data);
//         });
//       }
//     });
//     this.socket.connect();
//   } catch {
//     console.log("!!! Socket Implementation Failed.");
//   }
//   AppSingleton.cache = this;
// }

// export { AppSingleton, UserConfig };
import { createTheme } from "@mui/material/styles";
import { io } from "socket.io-client";
import { wsEndpoint } from "./backend";

function UserConfig() {
  if (typeof UserConfig.cache === "object") {
    return UserConfig.cache;
  }
  this.hkoLang = "tc";
  UserConfig.cache = this;
  return this; // Ensure the instance is returned
}

// 1. Declare a variable outside the function scope to hold our single instance
let instance = null;

function AppSingleton() {
  // 2. If an instance already exists, instantly return it without rebuilding the socket!
  if (instance) {
    return instance;
  }

  this.topBarHeight = 64;
  this.leavePage = () => {
    const onAnimationCompleted = () => {
      this.navigate(-1);
    };
    return onAnimationCompleted;
  };

  this.theme = createTheme({
    transitions: {
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
      },
    },
  });

  this.notifications = [];
  this.faiChunCallbackDict = {};
  this.faiChunResetCallbackDict = {};
  this.emojiCallback = {};

  try {
    // 3. This will now only execute ONCE for the entire lifespan of your app
    this.socket = io(wsEndpoint, {
      transports: ["websocket", "polling"], // Combined for Docker stability
      autoConnect: true,
    });
    console.log("🚀 Socket initialized for the FIRST time");

    this.socket.on("connect", () => {
      console.log("Connected to server");
    });
    this.socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });
    this.socket.on("message", (message) => {
      console.log(`on message: ${message}`);
      if (message.category === "fai_chun_broadcast") {
        console.log(this.faiChunCallbackDict);
        Object.values(this.faiChunCallbackDict).forEach((func) => func(message.data));
      } else if (message.category === "fai_chun_reset_broadcast") {
        console.log(this.faiChunResetCallbackDict);
        Object.values(this.faiChunResetCallbackDict).forEach((func) => func(message.data));
      } else if (message.category === "emoji_broadcast") {
        console.log(this.emojiCallback);
        Object.values(this.emojiCallback).forEach((func) => func(message.data));
      }
    });
  } catch (err) {
    console.log("!!! Socket Implementation Failed.", err);
  }

  // 4. Save this instance to our outer closure variable
  instance = this;
  return instance;
}

export { AppSingleton, UserConfig };
